<div class="header-trigger" (click)="appService.isSidebarCollapsed = !appService.isSidebarCollapsed">
  <span nz-icon [nzType]="appService.isSidebarCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
</div>
<ul
  nz-menu
  nzTheme="dark"
  nzMode="inline"
  class="app-sidebar"
  [nzInlineCollapsed]="appService.isSidebarCollapsed"
  [nzSelectable]="false"
>
  <!-- Builder -->
  <li nz-menu-item nzMatchRouter [routerLink]="['/home']" routerLinkActive="active">
    <span nz-icon nzType="home"></span>
    <span *ngIf="!appService.isSidebarCollapsed">Home</span>
  </li>
  <!-- data connection -->
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/data-connection']"
    routerLinkActive="active"
    *ngIf="authService.hasEntitlements(viewDataConnectionModule)"
  >
    <span nz-icon nzType="database"></span>
    <span *ngIf="!appService.isSidebarCollapsed">Data Connection</span>
  </li>
  <!-- Builder -->
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/query']"
    routerLinkActive="active"
    *ngIf="authService.hasEntitlements(viewQueryInterfaceModule)"
  >
    <span nz-icon nzType="build"></span>
    <span *ngIf="!appService.isSidebarCollapsed">Query Interface</span>
  </li>

  <!-- BI -->
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/bi']"
    routerLinkActive="active"
    *ngIf="authService.hasEntitlements(viewBiModule)"
  >
    <span nz-icon nzType="bar-chart"></span>
    <span *ngIf="!appService.isSidebarCollapsed">BI</span>
  </li>

  <!-- ML -->
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/ml']"
    routerLinkActive="active"
    *ngIf="authService.hasEntitlements(viewMlModule)"
  >
    <span nz-icon nzType="line-chart"></span>
    <span *ngIf="!appService.isSidebarCollapsed">ML</span>
  </li>

  <!-- Collaboration -->
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/collaboration']"
    routerLinkActive="active"
    *ngIf="authService.hasEntitlements(viewCollaborationModule)"
  >
    <span nz-icon nzType="team"></span>
    <span *ngIf="!appService.isSidebarCollapsed">Collaboration</span>
  </li>

  <!-- user management -->
  <li
    nz-menu-item
    nzMatchRouter
    [routerLink]="['/users']"
    routerLinkActive="active"
    *ngIf="authService.hasEntitlements(viewUserManagementModule)"
  >
    <span nz-icon nzType="user"></span>
    <span *ngIf="!appService.isSidebarCollapsed">Users</span>
  </li>
</ul>
